module.exports = __webpack_public_path__ + "static/media/9DESA33.08d1645a.jpg";